import {SelectFilterProvider} from '@github-ui/filter/providers'
import {RepoPushIcon} from '@primer/octicons-react'
import type {Ruleset} from '../../../types/rules-types'
import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter'

export class RulesetFilterProvider extends SelectFilterProvider {
  constructor(rulesets: Ruleset[]) {
    super(
      {
        displayName: 'Ruleset',
        key: 'ruleset',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: RepoPushIcon,
        description: 'Specify the ruleset',
      },
      rulesets.map((ruleset, index) => ({
        value: ruleset.name,
        displayName: ruleset.name,
        priority: index + 1,
      })),
      {
        filterTypes: {
          exclusive: false,
          valueless: false,
          hasValue: false,
          multiKey: false,
          multiValue: false,
        },
      },
    )
  }
}
